import { useCallback } from 'react';
import ParsedFieldIndicator from './ParsedFieldIndicator';

interface UseParsedFieldIndicatorProps {
	parsedDataSnapshot: any;
	formInstance: any;
}

export const useParsedFieldIndicator = ({
	parsedDataSnapshot,
	formInstance,
}: UseParsedFieldIndicatorProps) => {
	const getIndicator = useCallback(
		(fieldName: string) => {
			if (!parsedDataSnapshot) {
				return null;
			}

			const fieldMapping: Record<string, string> = {
				invoiceNumber: 'invoiceNumber',
				dateOfInvoice: 'invoiceDate',
				paymentTerms: 'paymentTerms',
				dueDate: 'dueDate',
				externalWorkOrderId: 'externalWorkOrderId',
				invoiceTotalBeforeTax: 'invoiceTotalBeforeTax',
				invoiceTax: 'invoiceTax',
				invoiceTotalAfterTax: 'invoiceTotalAfterTax',
				laborTotal: 'laborTotalBeforeTax',
				partsTotal: 'materialTotalBeforeTax',
				equipmentTotal: 'materialTotalBeforeTax',
				travelTotal: 'travelTotalBeforeTax',
				freightTotal: 'freightTotalBeforeTax',
				miscTotal: 'miscTotalBeforeTax',
			};

			const parsedFieldName = fieldMapping[fieldName];
			if (!parsedFieldName) {
				return null;
			}

			const currentValue = formInstance && formInstance.getFieldValue(fieldName);
			const parsedValue = parsedDataSnapshot[parsedFieldName];

			return (
				<ParsedFieldIndicator
					fieldName={fieldName}
					currentValue={currentValue}
					parsedValue={parsedValue}
					show={true}
				/>
			);
		},
		[parsedDataSnapshot, formInstance]
	);

	return { getIndicator };
};
